import axios from "axios";
import holidays from "../../models/horarios/holidays";
import holidaysSchedule from "../../models/horarios/holidaysSchedule";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getHolidays() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/gferiados`, { headers })

      .then(({ data }) => {
        return data.map((item) => {
          return holidays.fromJson(item);
        });
      });
  }
  getHolidaySchedule(id) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/horariofer/${id}`, { headers })

      .then(({ data }) => {
        return data.map((item) => {
          return holidaysSchedule.fromJson(item);
        });
      });
  }

  new(items) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const payload = {
      horarioId: items.scheduleId,
      lista: items.holidays,
    };

    return axios.post(`${url}/horariofer`, payload, { headers });
  }

  delete(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const schid = data.scheduleId;
    const type = data.id;
    return axios.delete(`${url}/horariofer/${schid}&${type}`, { headers });
  }
}
export default service;
